import { RoutePathsType } from "../types/routePaths";

export const RoutePaths: RoutePathsType = {
  NavBar: {
    primaryLinks: [
      {
        name: "人物",
        url: "/people",
      },
      {
        name: "生活",
        url: "/lifestyle",
      },
      {
        name: "星闻",
        url: "/celebs",
      },
      {
        name: "时尚",
        url: "/style",
      },
      {
        name: "美容",
        url: "/beauty",
      },
    ],
    utilityLinks: [
      {
        // Allow overwrite of name and url from data
        id: "magazineIssues",
        name: "Subscribe",
        url: "https://subscribe.sph.com.sg/package/subscribe-nuyou/",
        as: "button",
        variant: "primary",
        target: "_blank",
      },
    ],
    searchBarLink: {
      name: "Search",
      url: "/search",
    },
    mobileUtilityLinks: {
      // login: {
      //   name: "Login",
      //   url: "/",
      // },
    },
  },
  Footer: [
    {
      text: "关于我们",
      url: "/about-us",
    },
    {
      text: "广告合作伙伴",
      url: "https://www.sph.com.sg/advertising-solutions/",
      target: "_blank",
    },
    {
      text: "联系我们",
      url: "https://www.sph.com.sg/contact-us/",
      target: "_blank",
    },
    {
      text: "免責聲明",
      url: "https://www.sph.com.sg/legal/website_tnc/",
      target: "_blank",
    },
    {
      text: "隐私权政策",
      url: "https://www.sph.com.sg/legal/sph_privacy/",
      target: "_blank",
    },
    {
      text: "个人资料保护法令",
      url: "https://www.sph.com.sg/legal/pdpa/",
      target: "_blank",
    },
  ],
  MegaMenu: [
    {
      text: "人物",
      url: "/people",
      placement: "left",
      subMenu: [
        {
          text: "The Millennial Talk",
          url: "/tag/the-millennial-talk",
        },
        {
          text: "Men We Love",
          url: "/tag/men-we-love",
        },
        {
          text: "Faces To Watch",
          url: "/tag/faces-to-watch",
        },
      ],
    },
    {
      text: "生活",
      url: "/lifestyle",
      placement: "left",
      subMenu: [
        {
          text: "Relationship",
          url: "/tag/relationship",
        },
        {
          text: "Dining",
          url: "/tag/dining",
        },
        {
          text: "Travel",
          url: "/tag/travel",
        },
      ],
    },
    {
      text: "星闻",
      url: "/celebs",
      placement: "left",
      subMenu: [
        {
          text: "Cover Story",
          url: "/tag/cover-story",
        },
        {
          text: "Behind-The-Scenes",
          url: "/tag/bts",
        },
      ],
    },
    {
      text: "时尚",
      url: "/style",
      placement: "left",
      subMenu: [
        {
          text: "Tips",
          url: "/tag/tips",
        },
        {
          text: "Celebrity Looks",
          url: "/tag/celebrity-looks",
        },
        {
          text: "Watches & Jewellery",
          url: "/tag/watches-jewellery",
        },
        {
          text: "Men",
          url: "/tag/men",
        },
      ],
    },
    {
      text: "美容",
      url: "/beauty",
      placement: "left",
      subMenu: [
        {
          text: "Best Buys",
          url: "/tag/best-buys",
        },
        {
          text: "Reviews",
          url: "/tag/beauty-reviews",
        },
        {
          text: "Celebrity Beauty",
          url: "/tag/celeb-beauty",
        },
      ],
    },
  ],
};
